import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/payment-methods',
    name: RouteName.SettingsPaymentMethods,
    component: () => import('@/pages/Settings/PaymentMethods.vue'),
    meta: {
      permissions: [CRMPermission.PaymentMethods],
      breadcrumb: {
        label: 'Методы оплаты',
        parent: RouteName.Settings,
      },
    },
  },
]
